const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token) => {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const getBrainGraph = async ({ query = "", memoryType = "", dateFrom = "", dateTo = "", profileUserId = "" } = {}, token) => {
  const params = new URLSearchParams();
  if (query) params.set("query", query);
  if (memoryType) params.set("memory_type", memoryType);
  if (dateFrom) params.set("date_from", dateFrom);
  if (dateTo) params.set("date_to", dateTo);
  if (profileUserId) params.set("profile_user_id", profileUserId);
  return request(`/brain/graph?${params.toString()}`, token);
};

export const getBrainNode = async (nodeId, profileUserId, token) => {
  const params = new URLSearchParams({ node_id: nodeId });
  if (profileUserId) params.set("profile_user_id", profileUserId);
  return request(`/brain/node?${params.toString()}`, token);
};
